<span
  class="status-badge"
  [ngClass]="{
    'status-info': status === 'Scheduled' || status === 'Split',
    'status-success': status === 'Running',
    'status-warning': status === 'Seating',
    'status-error': status === 'Finished',
    'status-muted': status === 'Merged'
  }"
  >@if (status === 'Running' || status === 'Seating') {
  <span class="status-dot"></span>
}{{ status | uppercase | translate }}</span>
